export default __webpack_public_path__ + "static/media/noe-display-bold.5080e75f.woff";